/**
 * ext-components-pro
 *
 * Adapptio: Set of pro components
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IAppClient, ITranslationManager } from "@adapptio/lib-core";
import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericViewComponentDefinition } from "@adapptio/lib-components";
import { registerComponents } from "./index";

export const registerExtension = (application: IAppClient): void => {
	const registry = application.get("componentRegistry");
	const translationManager = application.get("translationManager");

	registerComponents(registry, translationManager);
};

export const registerStandalone = (
	registry: ItemRegistry<TGenericViewComponentDefinition>,
	translationManager: ITranslationManager
): void => {
	registerComponents(registry, translationManager);
};
